<!-- Young -->
<template>
  <div class="account-ec">
    <public-bread-crumb :routes="routes"></public-bread-crumb>
    <div class="content-wrap">
      <p class="page-title">{{ title }}</p>
      <div class="from-wrap">
        <a-spin :spinning="formLoading" :delay="delayTime">
          <a-form :form="form" style="width: 100%">
            <a-row>
              <a-col
                style="display: flex; width: 1000px; margin-top: -50px"
                :push="1"
              >
                <div
                  class="select-btn"
                  @click="Fun_selectBtn(0)"
                  :style="{ border: selectBtn == 0 ? '2px solid #5364C7' : '' }"
                >
                  <div>不接入健康码</div>
                  <img
                    :src="selectPng"
                    class="select-logo"
                    v-show="selectBtn == 0"
                  />
                </div>
                <div
                  class="select-btn"
                  @click="Fun_selectBtn(1)"
                  :style="{ border: selectBtn == 1 ? '2px solid #5364C7' : '' }"
                >
                  <div>
                    <img :src="codeLogo" style="width: 24px; height: 24px" />
                    陕西一码通
                  </div>
                  <img
                    :src="selectPng"
                    class="select-logo"
                    v-show="selectBtn == 1"
                  />
                </div>
                <div
                  class="select-btn"
                  @click="Fun_selectBtn(5)"
                  :style="{ border: selectBtn == 5 ? '2px solid #5364C7' : '' }"
                >
                  <div>西安纳管</div>
                  <img
                    :src="selectPng"
                    class="select-logo"
                    v-show="selectBtn == 5"
                  />
                </div>
                <div
                  class="select-btn"
                  @click="Fun_selectBtn(2)"
                  :style="{ border: selectBtn == 2 ? '2px solid #5364C7' : '' }"
                >
                  <div>新疆防疫</div>
                  <img
                    :src="selectPng"
                    class="select-logo"
                    v-show="selectBtn == 2"
                  />
                </div>
                <div
                  class="select-btn"
                  @click="Fun_selectBtn(3)"
                  :style="{ border: selectBtn == 3 ? '2px solid #5364C7' : '' }"
                >
                  <div>河北健康码</div>
                  <img
                    :src="selectPng"
                    class="select-logo"
                    v-show="selectBtn == 3"
                  />
                </div>
                <div
                  class="select-btn"
                  @click="Fun_selectBtn(4)"
                  :style="{ border: selectBtn == 4 ? '2px solid #5364C7' : '' }"
                >
                  <div>宝鸡纳管</div>
                  <img
                    :src="selectPng"
                    class="select-logo"
                    v-show="selectBtn == 4"
                  />
                </div>
              </a-col>
            </a-row>
            <div class="onecode-item">
              <!-- 不接入健康码 -->
              <div v-show="selectBtn == 0">
                <!-- <a-row style="padding-top: 30px">
                  <a-col :span="8" :push="2">
                    <a-form-item
                      :labelCol="{ span: 9 }"
                      :wrapperCol="{ span: 15 }"
                    >
                      <label slot="label"
                        >认证模式&nbsp;:&nbsp;人脸&nbsp;</label
                      >
                      <a-radio-group
                        v-decorator="[
                          'faceMode',
                          {
                            initialValue: true,
                            rules: [
                              { required: true, validator: CheckfaceMode }
                            ]
                          }
                        ]"
                      >
                        <a-radio :value="true"> 匹配底库 </a-radio>
                        <a-radio :value="false"> 不匹配底库 </a-radio>
                      </a-radio-group>
                      <span style="color: #aaa">|</span>
                    </a-form-item>
                  </a-col>
                  <a-col :span="7" :push="1">
                    <a-form-item
                      label="健康码"
                      :labelCol="{ span: 5 }"
                      :wrapperCol="{ span: 18 }"
                    >
                      <a-radio-group
                        :disabled="isfacemodedisabled"
                        v-decorator="[
                          'eventType2',
                          {
                            initialValue: false,
                            rules: [
                              { required: false, message: '请选择认证模式' }
                            ]
                          }
                        ]"
                      >
                        <a-radio :value="true"> 匹配底库 </a-radio>
                        <a-radio :value="false"> 不匹配底库 </a-radio>
                      </a-radio-group>
                      <span style="color: #aaa">|</span>
                    </a-form-item>
                  </a-col>
                  <a-col :span="7">
                    <a-form-item
                      label="身份证"
                      :labelCol="{ span: 4 }"
                      :wrapperCol="{ span: 20 }"
                    >
                      <a-radio-group
                        :disabled="isfacemodedisabled"
                        v-decorator="[
                          'eventType3',
                          {
                            initialValue: false,
                            rules: [
                              { required: false, message: '请选择认证模式' }
                            ]
                          }
                        ]"
                      >
                        <a-radio :value="true"> 匹配底库 </a-radio>
                        <a-radio :value="false"> 不匹配底库 </a-radio>
                      </a-radio-group>
                    </a-form-item>
                  </a-col>
                  <a-col :span="20" :push="4">
                    <span style="position: relative; top: -24px; color: #7f7f7f"
                      >匹配底库：仅允许内部人员或访客通行；不匹配底库：允许外来人员通行</span
                    >
                  </a-col>
                </a-row> -->
              </div>
              <!-- 陕西一码通 -->
              <div v-show="selectBtn == 1">
                <a-row style="margin-top: 30px">
                  <a-col :span="10">
                    <a-form-item
                      label="经纬度"
                      :labelCol="{ span: 10 }"
                      :wrapperCol="{ span: 14 }"
                      :required="checkFlag"
                    >
                      <a-input
                        :disabled="true"
                        style="width: 204px"
                        :labelCol="{ span: 10 }"
                        :wrapperCol="{ span: 14 }"
                        v-decorator="[
                          'longitudeAndLatitude',
                          {
                            initialValue: '',
                            rules: [
                              { required: checkFlag, message: '请输入经纬度' }
                            ]
                          }
                        ]"
                        placeholder="请输入经纬度"
                      />
                      <a-button type="primary" @click="Fun_Map"
                        >拾取坐标
                      </a-button>
                    </a-form-item>
                  </a-col>
                  <a-col :span="10">
                    <a-form-item
                      label="设备进出方向"
                      :labelCol="{ span: 10 }"
                      :wrapperCol="{ span: 14 }"
                      required
                    >
                      <a-select
                        v-decorator="[
                          'eventInOut',
                          {
                            initialValue: 1,
                            rules: [
                              { required: true, message: '请选择设备进出方向' }
                            ]
                          }
                        ]"
                        placeholder="请选择设备进出方向"
                      >
                        <a-select-option :value="1"> 进 </a-select-option>
                        <a-select-option :value="2"> 出 </a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :span="10">
                    <a-form-item
                      label="行政区域"
                      :labelCol="{ span: 10 }"
                      :wrapperCol="{ span: 14 }"
                      required
                    >
                      <a-select
                        v-decorator="[
                          'regionCode',
                          {
                            rules: [
                              { required: true, message: '请选择行政区域' }
                            ]
                          }
                        ]"
                        placeholder="请选择行政区域"
                      >
                        <a-select-option
                          v-for="i in treeAreaData"
                          :key="i.id"
                          :value="i.id"
                        >
                          {{ i.name }}
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :span="10">
                    <a-form-item
                      label="地址"
                      :labelCol="{ span: 10 }"
                      :wrapperCol="{ span: 14 }"
                      required
                    >
                      <a-input
                        v-decorator="[
                          'installLocation',
                          {
                            rules: [{ required: true, message: '请输入地址' }]
                          }
                        ]"
                        placeholder="请输入地址"
                      />
                    </a-form-item>
                  </a-col>
                  <a-col :span="10">
                    <a-form-item
                      label="区域类型"
                      :labelCol="{ span: 10 }"
                      :wrapperCol="{ span: 14 }"
                      required
                    >
                      <a-select
                        v-decorator="[
                          'regionType',
                          {
                            rules: [
                              { required: true, message: '请选择区域类型' }
                            ]
                          }
                        ]"
                        placeholder="请选择区域类型"
                      >
                        <a-select-option
                          v-for="i in regionTypeData"
                          :key="i.code"
                          :value="i.code"
                        >
                          {{ i.name }}
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :span="10">
                    <a-form-item
                      label="一码通地点码"
                      :labelCol="{ span: 10 }"
                      :wrapperCol="{ span: 14 }"
                    >
                      <a-input
                        v-decorator="[
                          'Qrid',
                          {
                            rules: [
                              { required: true, message: '请输入一码通地点码' }
                            ]
                          }
                        ]"
                        placeholder="请输入一码通地点码"
                      />
                    </a-form-item>
                  </a-col>
                  <a-col :span="10">
                    <a-form-item
                      label="核酸限制"
                      :labelCol="{ span: 10 }"
                      :wrapperCol="{ span: 14 }"
                      required
                    >
                      <a-select
                        v-decorator="[
                          'pcrRules',
                          {
                            initialValue: 5,
                            rules: [
                              { required: true, message: '请选择核酸限制' }
                            ]
                          }
                        ]"
                        placeholder="请选择核酸限制"
                      >
                        <a-select-option
                          v-for="i in pcrRulesTypeData"
                          :key="i.code"
                          :value="i.code"
                        >
                          {{ i.name }}
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                </a-row>
                <a-row>
                  <a-col :span="8" :push="2">
                    <a-form-item
                      :labelCol="{ span: 9 }"
                      :wrapperCol="{ span: 15 }"
                    >
                      <label slot="label"
                        >认证模式&nbsp;:&nbsp;人脸&nbsp;</label
                      >
                      <a-radio-group
                        v-decorator="[
                          'faceMode',
                          {
                            initialValue: true,
                            rules: [
                              { required: true, validator: CheckfaceMode }
                            ]
                          }
                        ]"
                      >
                        <a-radio :value="true"> 匹配底库 </a-radio>
                        <a-radio :value="false"> 不匹配底库 </a-radio>
                      </a-radio-group>
                      <span style="color: #aaa">|</span>
                    </a-form-item>
                  </a-col>
                  <a-col :span="7" :push="1">
                    <a-form-item
                      label="健康码"
                      :labelCol="{ span: 5 }"
                      :wrapperCol="{ span: 18 }"
                    >
                      <a-radio-group
                        :disabled="isfacemodedisabled"
                        v-decorator="[
                          'eventType2',
                          {
                            initialValue: false,
                            rules: [
                              { required: false, message: '请选择认证模式' }
                            ]
                          }
                        ]"
                      >
                        <a-radio :value="true"> 匹配底库 </a-radio>
                        <a-radio :value="false"> 不匹配底库 </a-radio>
                      </a-radio-group>
                      <span style="color: #aaa">|</span>
                    </a-form-item>
                  </a-col>
                  <a-col :span="7">
                    <a-form-item
                      label="身份证"
                      :labelCol="{ span: 4 }"
                      :wrapperCol="{ span: 20 }"
                    >
                      <a-radio-group
                        :disabled="isfacemodedisabled"
                        v-decorator="[
                          'eventType3',
                          {
                            initialValue: false,
                            rules: [
                              { required: false, message: '请选择认证模式' }
                            ]
                          }
                        ]"
                      >
                        <a-radio :value="true"> 匹配底库 </a-radio>
                        <a-radio :value="false"> 不匹配底库 </a-radio>
                      </a-radio-group>
                    </a-form-item>
                  </a-col>
                  <a-col :span="20" :push="4">
                    <span style="position: relative; top: -24px; color: #7f7f7f"
                      >匹配底库：仅允许内部人员或访客通行；不匹配底库：允许外来人员通行</span
                    >
                  </a-col>
                </a-row>
              </div>
              <!-- 西安纳管 -->
              <div v-show="selectBtn == 5">
                <a-row style="margin-top: 30px">
                  <a-col :span="10">
                    <a-form-item
                      label="经纬度"
                      :labelCol="{ span: 10 }"
                      :wrapperCol="{ span: 14 }"
                      required
                    >
                      <a-input
                        :disabled="true"
                        style="width: 204px"
                        :labelCol="{ span: 10 }"
                        :wrapperCol="{ span: 14 }"
                        v-decorator="[
                          'longitudeAndLatitude',
                          {
                            initialValue: '',
                            rules: [{ required: true, message: '请输入经纬度' }]
                          }
                        ]"
                        placeholder="请输入经纬度"
                      />
                      <a-button type="primary" @click="Fun_Map"
                        >拾取坐标
                      </a-button>
                    </a-form-item>
                  </a-col>
                  <a-col :span="10">
                    <a-form-item
                      label="设备进出方向"
                      :labelCol="{ span: 10 }"
                      :wrapperCol="{ span: 14 }"
                      required
                    >
                      <a-select
                        v-decorator="[
                          'eventInOut',
                          {
                            initialValue: 1,
                            rules: [
                              { required: true, message: '请选择设备进出方向' }
                            ]
                          }
                        ]"
                        placeholder="请选择设备进出方向"
                      >
                        <a-select-option :value="1"> 进 </a-select-option>
                        <a-select-option :value="2"> 出 </a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :span="10">
                    <a-form-item
                      label="行政区域"
                      :labelCol="{ span: 10 }"
                      :wrapperCol="{ span: 14 }"
                      required
                    >
                      <a-select
                        v-decorator="[
                          'regionCode',
                          {
                            rules: [
                              { required: true, message: '请选择行政区域' }
                            ]
                          }
                        ]"
                        placeholder="请选择行政区域"
                      >
                        <a-select-option
                          v-for="i in treeAreaData"
                          :key="i.id"
                          :value="i.id"
                        >
                          {{ i.name }}
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :span="10">
                    <a-form-item
                      label="地址"
                      :labelCol="{ span: 10 }"
                      :wrapperCol="{ span: 14 }"
                      required
                    >
                      <a-input
                        v-decorator="[
                          'installLocation',
                          {
                            rules: [{ required: true, message: '请输入地址' }]
                          }
                        ]"
                        placeholder="请输入地址"
                      />
                    </a-form-item>
                  </a-col>
                  <a-col :span="10">
                    <a-form-item
                      label="区域类型"
                      :labelCol="{ span: 10 }"
                      :wrapperCol="{ span: 14 }"
                      required
                    >
                      <a-select
                        v-decorator="[
                          'regionType',
                          {
                            rules: [
                              { required: true, message: '请选择区域类型' }
                            ]
                          }
                        ]"
                        placeholder="请选择区域类型"
                      >
                        <a-select-option
                          v-for="i in regionTypeData"
                          :key="i.code"
                          :value="i.code"
                        >
                          {{ i.name }}
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :span="10">
                    <a-form-item
                      label="一码通地点码"
                      :labelCol="{ span: 10 }"
                      :wrapperCol="{ span: 14 }"
                    >
                      <a-input
                        v-decorator="[
                          'Qrid',
                          {
                            rules: [
                              { required: true, message: '请输入一码通地点码' }
                            ]
                          }
                        ]"
                        placeholder="请输入一码通地点码"
                      />
                    </a-form-item>
                  </a-col>
                  <a-col :span="10">
                    <a-form-item
                      label="密钥"
                      :labelCol="{ span: 10 }"
                      :wrapperCol="{ span: 14 }"
                    >
                      <a-input
                        v-decorator="[
                          'doorSecret',
                          {
                            rules: [{ required: true, message: '请输入密钥' }]
                          }
                        ]"
                        placeholder="请输入密钥"
                      />
                    </a-form-item>
                  </a-col>
                  <a-col :span="10">
                    <a-form-item
                      label="场景路由"
                      :labelCol="{ span: 10 }"
                      :wrapperCol="{ span: 14 }"
                    >
                      <a-select
                        v-decorator="[
                          'scenes',
                          {
                            rules: [
                              { required: true, message: '请选择场景路由' }
                            ]
                          }
                        ]"
                        placeholder="请选择场景路由"
                        allowClear
                      >
                        <a-select-option
                          v-for="i in scenesData"
                          :key="i.id"
                          :value="i.id"
                        >
                          {{ i.name }}
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :span="10">
                    <a-form-item
                      label="核酸限制"
                      :labelCol="{ span: 10 }"
                      :wrapperCol="{ span: 14 }"
                      required
                    >
                      <a-select
                        v-decorator="[
                          'pcrRules',
                          {
                            initialValue: 5,
                            rules: [
                              { required: true, message: '请选择核酸限制' }
                            ]
                          }
                        ]"
                        placeholder="请选择核酸限制"
                        allowClear
                      >
                        <a-select-option
                          v-for="i in pcrRulesTypeData"
                          :key="i.code"
                          :value="i.code"
                        >
                          {{ i.name }}
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                </a-row>

                <a-row>
                  <a-col :span="8" :push="2">
                    <a-form-item
                      :labelCol="{ span: 9 }"
                      :wrapperCol="{ span: 15 }"
                    >
                      <label slot="label"
                        >认证模式&nbsp;:&nbsp;人脸&nbsp;</label
                      >
                      <a-radio-group
                        v-decorator="[
                          'faceMode',
                          {
                            initialValue: true,
                            rules: [
                              { required: true, validator: CheckfaceMode }
                            ]
                          }
                        ]"
                      >
                        <a-radio :value="true"> 匹配底库 </a-radio>
                        <a-radio :value="false"> 不匹配底库 </a-radio>
                      </a-radio-group>
                      <span style="color: #aaa">|</span>
                    </a-form-item>
                  </a-col>
                  <a-col :span="7" :push="1">
                    <a-form-item
                      label="健康码"
                      :labelCol="{ span: 5 }"
                      :wrapperCol="{ span: 18 }"
                    >
                      <a-radio-group
                        :disabled="isfacemodedisabled"
                        v-decorator="[
                          'eventType2',
                          {
                            initialValue: false,
                            rules: [
                              { required: false, message: '请选择认证模式' }
                            ]
                          }
                        ]"
                      >
                        <a-radio :value="true"> 匹配底库 </a-radio>
                        <a-radio :value="false"> 不匹配底库 </a-radio>
                      </a-radio-group>
                      <span style="color: #aaa">|</span>
                    </a-form-item>
                  </a-col>
                  <a-col :span="7">
                    <a-form-item
                      label="身份证"
                      :labelCol="{ span: 4 }"
                      :wrapperCol="{ span: 20 }"
                    >
                      <a-radio-group
                        :disabled="isfacemodedisabled"
                        v-decorator="[
                          'eventType3',
                          {
                            initialValue: false,
                            rules: [
                              { required: false, message: '请选择认证模式' }
                            ]
                          }
                        ]"
                      >
                        <a-radio :value="true"> 匹配底库 </a-radio>
                        <a-radio :value="false"> 不匹配底库 </a-radio>
                      </a-radio-group>
                    </a-form-item>
                  </a-col>
                  <a-col :span="20" :push="4">
                    <span style="position: relative; top: -24px; color: #7f7f7f"
                      >匹配底库：仅允许内部人员或访客通行；不匹配底库：允许外来人员通行</span
                    >
                  </a-col>
                </a-row>
              </div>
              <!-- 新疆防疫 -->
              <div v-show="selectBtn == 2">
                <a-row style="margin-top: 30px">
                  <a-col :span="10">
                    <a-form-item
                      label="场所码标识"
                      :labelCol="{ span: 10 }"
                      :wrapperCol="{ span: 14 }"
                    >
                      <a-input
                        v-decorator="[
                          'placeguid',
                          {
                            rules: [
                              { required: true, message: '请输入场所码标识' }
                            ]
                          }
                        ]"
                        placeholder="请输入场所码标识"
                      />
                    </a-form-item>
                  </a-col>
                  <a-col :span="10">
                    <a-form-item
                      label="APPID"
                      :labelCol="{ span: 10 }"
                      :wrapperCol="{ span: 14 }"
                    >
                      <a-input
                        v-decorator="[
                          'appid',
                          {
                            rules: [{ required: true, message: '请输入appid' }]
                          }
                        ]"
                        placeholder="请输入appid"
                      />
                    </a-form-item>
                  </a-col>
                  <a-col :span="10">
                    <a-form-item
                      label="区划代码"
                      :labelCol="{ span: 10 }"
                      :wrapperCol="{ span: 14 }"
                    >
                      <a-input
                        v-decorator="[
                          'areacode',
                          {
                            rules: [
                              { required: true, message: '请输入区划代码' }
                            ]
                          }
                        ]"
                        placeholder="请输入区划代码"
                      />
                    </a-form-item>
                  </a-col>
                </a-row>
                <a-row>
                  <a-col :span="8" :push="2">
                    <a-form-item
                      :labelCol="{ span: 9 }"
                      :wrapperCol="{ span: 15 }"
                    >
                      <label slot="label"
                        >认证模式&nbsp;:&nbsp;人脸&nbsp;</label
                      >
                      <a-radio-group
                        v-decorator="[
                          'faceMode',
                          {
                            initialValue: true,
                            rules: [
                              { required: true, validator: CheckfaceMode }
                            ]
                          }
                        ]"
                      >
                        <a-radio :value="true"> 匹配底库 </a-radio>
                        <a-radio :value="false"> 不匹配底库 </a-radio>
                      </a-radio-group>
                      <span style="color: #aaa">|</span>
                    </a-form-item>
                  </a-col>
                  <a-col :span="7" :push="1">
                    <a-form-item
                      label="健康码"
                      :labelCol="{ span: 5 }"
                      :wrapperCol="{ span: 18 }"
                    >
                      <a-radio-group
                        :disabled="isfacemodedisabled"
                        v-decorator="[
                          'eventType2',
                          {
                            initialValue: false,
                            rules: [
                              { required: false, message: '请选择认证模式' }
                            ]
                          }
                        ]"
                      >
                        <a-radio :value="true"> 匹配底库 </a-radio>
                        <a-radio :value="false"> 不匹配底库 </a-radio>
                      </a-radio-group>
                      <span style="color: #aaa">|</span>
                    </a-form-item>
                  </a-col>
                  <a-col :span="7">
                    <a-form-item
                      label="身份证"
                      :labelCol="{ span: 4 }"
                      :wrapperCol="{ span: 20 }"
                    >
                      <a-radio-group
                        :disabled="isfacemodedisabled"
                        v-decorator="[
                          'eventType3',
                          {
                            initialValue: false,
                            rules: [
                              { required: false, message: '请选择认证模式' }
                            ]
                          }
                        ]"
                      >
                        <a-radio :value="true"> 匹配底库 </a-radio>
                        <a-radio :value="false"> 不匹配底库 </a-radio>
                      </a-radio-group>
                    </a-form-item>
                  </a-col>
                  <a-col :span="20" :push="4">
                    <span style="position: relative; top: -24px; color: #7f7f7f"
                      >匹配底库：仅允许内部人员或访客通行；不匹配底库：允许外来人员通行</span
                    >
                  </a-col>
                </a-row>
              </div>
              <!-- 河北健康码 -->
              <div v-show="selectBtn == 3"></div>
              <!-- 宝鸡纳管 -->
              <div v-show="selectBtn == 4">
                <a-row style="margin-top: 30px">
                  <a-col :span="10">
                    <a-form-item
                      label="经纬度"
                      :labelCol="{ span: 10 }"
                      :wrapperCol="{ span: 14 }"
                      required
                    >
                      <a-input
                        :disabled="true"
                        style="width: 204px"
                        :labelCol="{ span: 10 }"
                        :wrapperCol="{ span: 14 }"
                        v-decorator="[
                          'longitudeAndLatitude',
                          {
                            initialValue: '',
                            rules: [{ required: true, message: '请输入经纬度' }]
                          }
                        ]"
                        placeholder="请输入经纬度"
                      />
                      <a-button type="primary" @click="Fun_Map"
                        >拾取坐标
                      </a-button>
                    </a-form-item>
                  </a-col>
                  <a-col :span="10">
                    <a-form-item
                      label="设备进出方向"
                      :labelCol="{ span: 10 }"
                      :wrapperCol="{ span: 14 }"
                      required
                    >
                      <a-select
                        v-decorator="[
                          'eventInOut',
                          {
                            initialValue: 1,
                            rules: [
                              { required: true, message: '请选择设备进出方向' }
                            ]
                          }
                        ]"
                        placeholder="请选择设备进出方向"
                      >
                        <a-select-option :value="1"> 进 </a-select-option>
                        <a-select-option :value="2"> 出 </a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :span="10">
                    <a-form-item
                      label="行政区域"
                      :labelCol="{ span: 10 }"
                      :wrapperCol="{ span: 14 }"
                      required
                    >
                      <a-select
                        v-decorator="[
                          'regionCode',
                          {
                            rules: [
                              { required: true, message: '请选择行政区域' }
                            ]
                          }
                        ]"
                        placeholder="请选择行政区域"
                      >
                        <a-select-option
                          v-for="i in treeAreaData"
                          :key="i.id"
                          :value="i.id"
                        >
                          {{ i.name }}
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :span="10">
                    <a-form-item
                      label="地址"
                      :labelCol="{ span: 10 }"
                      :wrapperCol="{ span: 14 }"
                      required
                    >
                      <a-input
                        v-decorator="[
                          'installLocation',
                          {
                            rules: [{ required: true, message: '请输入地址' }]
                          }
                        ]"
                        placeholder="请输入地址"
                      />
                    </a-form-item>
                  </a-col>
                  <a-col :span="10">
                    <a-form-item
                      label="区域类型"
                      :labelCol="{ span: 10 }"
                      :wrapperCol="{ span: 14 }"
                      required
                    >
                      <a-select
                        v-decorator="[
                          'regionType',
                          {
                            rules: [
                              { required: true, message: '请选择区域类型' }
                            ]
                          }
                        ]"
                        placeholder="请选择区域类型"
                      >
                        <a-select-option
                          v-for="i in regionTypeData"
                          :key="i.code"
                          :value="i.code"
                        >
                          {{ i.name }}
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :span="10">
                    <a-form-item
                      label="一码通地点码"
                      :labelCol="{ span: 10 }"
                      :wrapperCol="{ span: 14 }"
                    >
                      <a-input
                        v-decorator="[
                          'Qrid',
                          {
                            rules: [
                              { required: true, message: '请输入一码通地点码' }
                            ]
                          }
                        ]"
                        placeholder="请输入一码通地点码"
                      />
                    </a-form-item>
                  </a-col>
                  <a-col :span="10">
                    <a-form-item
                      label="密钥"
                      :labelCol="{ span: 10 }"
                      :wrapperCol="{ span: 14 }"
                    >
                      <a-input
                        v-decorator="[
                          'doorSecret',
                          {
                            rules: [{ required: true, message: '请输入密钥' }]
                          }
                        ]"
                        placeholder="请输入密钥"
                      />
                    </a-form-item>
                  </a-col>
                  <a-col :span="10">
                    <a-form-item
                      label="场景路由"
                      :labelCol="{ span: 10 }"
                      :wrapperCol="{ span: 14 }"
                    >
                      <a-select
                        v-decorator="[
                          'scenes',
                          {
                            rules: [
                              { required: true, message: '请选择场景路由' }
                            ]
                          }
                        ]"
                        placeholder="请选择场景路由"
                        allowClear
                      >
                        <a-select-option
                          v-for="i in scenesData"
                          :key="i.id"
                          :value="i.id"
                        >
                          {{ i.name }}
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :span="10">
                    <a-form-item
                      label="核酸限制"
                      :labelCol="{ span: 10 }"
                      :wrapperCol="{ span: 14 }"
                      required
                    >
                      <a-select
                        v-decorator="[
                          'pcrRules',
                          {
                            initialValue: 5,
                            rules: [
                              { required: true, message: '请选择核酸限制' }
                            ]
                          }
                        ]"
                        placeholder="请选择核酸限制"
                        allowClear
                      >
                        <a-select-option
                          v-for="i in pcrRulesTypeData"
                          :key="i.code"
                          :value="i.code"
                        >
                          {{ i.name }}
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                </a-row>
                <a-row>
                  <a-col :span="8" :push="2">
                    <a-form-item
                      :labelCol="{ span: 9 }"
                      :wrapperCol="{ span: 15 }"
                    >
                      <label slot="label"
                        >认证模式&nbsp;:&nbsp;人脸&nbsp;</label
                      >
                      <a-radio-group
                        v-decorator="[
                          'faceMode',
                          {
                            initialValue: true,
                            rules: [
                              { required: true, validator: CheckfaceMode }
                            ]
                          }
                        ]"
                      >
                        <a-radio :value="true"> 匹配底库 </a-radio>
                        <a-radio :value="false"> 不匹配底库 </a-radio>
                      </a-radio-group>
                      <span style="color: #aaa">|</span>
                    </a-form-item>
                  </a-col>
                  <a-col :span="7" :push="1">
                    <a-form-item
                      label="健康码"
                      :labelCol="{ span: 5 }"
                      :wrapperCol="{ span: 18 }"
                    >
                      <a-radio-group
                        :disabled="isfacemodedisabled"
                        v-decorator="[
                          'eventType2',
                          {
                            initialValue: false,
                            rules: [
                              { required: false, message: '请选择认证模式' }
                            ]
                          }
                        ]"
                      >
                        <a-radio :value="true"> 匹配底库 </a-radio>
                        <a-radio :value="false"> 不匹配底库 </a-radio>
                      </a-radio-group>
                      <span style="color: #aaa">|</span>
                    </a-form-item>
                  </a-col>
                  <a-col :span="7">
                    <a-form-item
                      label="身份证"
                      :labelCol="{ span: 4 }"
                      :wrapperCol="{ span: 20 }"
                    >
                      <a-radio-group
                        :disabled="isfacemodedisabled"
                        v-decorator="[
                          'eventType3',
                          {
                            initialValue: false,
                            rules: [
                              { required: false, message: '请选择认证模式' }
                            ]
                          }
                        ]"
                      >
                        <a-radio :value="true"> 匹配底库 </a-radio>
                        <a-radio :value="false"> 不匹配底库 </a-radio>
                      </a-radio-group>
                    </a-form-item>
                  </a-col>
                  <a-col :span="20" :push="4">
                    <span style="position: relative; top: -24px; color: #7f7f7f"
                      >匹配底库：仅允许内部人员或访客通行；不匹配底库：允许外来人员通行</span
                    >
                  </a-col>
                </a-row>
              </div>
            </div>
            <a-col :span="24">
              <div class="btn-wrap">
                <a-button
                  type="primary"
                  class="tool-btn"
                  style="margin-right: 32px"
                  @click="handleSubmit"
                  :loading="btnLoading"
                  >保存</a-button
                >
                <a-button
                  class="tool-btn"
                  style="color: #5862cb; background: #ecedff"
                  @click="$router.push('/access-control')"
                  >取消</a-button
                >
              </div>
            </a-col>
          </a-form>
        </a-spin>
      </div>
    </div>
    <map-modal
      v-if="showModal"
      :showModal="showModal"
      :modalArr="modalArr"
      @Ok="handleModalOk"
      @cancel="handleModalCancel"
    >
    </map-modal>
  </div>
</template>

<script>
import ACServices from "@/services/accessControl.services";
import selectPng from "./assets/select.png";
import codeLogo from "./assets/code.png";
import { mapModal } from "./components";
export default {
  name: "AccessEC",
  inject: ["reload"],
  components: { mapModal },
  data() {
    return {
      isfacemodedisabled: false,
      healthCodeParameterStr: {},
      scenesStr: "",
      doorSecretStr: "",
      delayTime: 500,
      checkFlag: false,
      title: "一码通设置",
      modalArr: {},
      showModal: false,
      treeData: [],
      treeAreaData: [], //行政区域
      regionTypeData: [], //区域类型
      scenesData: [], //场景路由
      pcrRulesTypeData: [], //核酸限制
      btnLoading: false,
      selectPng,
      codeLogo,
      selectBtn: 1,
      form: this.$form.createForm(this, { name: "AccessForm" }),
      pwdReg: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/,
      id: "",
      formLoading: false,
      oldUserPhone: ""
      //   formFields: [
      //     "longitudeAndLatitude",
      //     "eventInOut",
      //     "regionCode",
      //     "installLocation",
      //     "regionType",
      //     "Qrid",
      //     "pcrRules",
      //     "doorSecret",
      //     "scenes",
      //     "faceMode",
      //     "eventType2",
      //     "eventType3",
      //     "placeguid",
      //     "appid",
      //     "areacode",
      //   ],
    };
  },
  computed: {
    // 监听属性 类似于data概念
    routes() {
      return [
        {
          name: "门禁设备管理",
          path: "/access-control"
        },
        {
          name: this.title,
          path: ""
        }
      ];
    }
  },
  async mounted() {
    this.formLoading = true;
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
      await this.getInfo();
    }
    // await this.getDoorEquGroupList();
    await this.getAreaCodeList(); //行政区域列表
    await this.getRegionTypeList(); //区域类型列表区域类型列表
    await this.getScenesTypeList(); //获取场景路由数据
    this.getpcrRulesTypeList(); //获取核酸数据
    await this.form.validateFields(["faceMode"]);
    /*
    编辑模式
    >>根据传入的ID,调接口获得表单的数据
    >>通过setFieldsValue({控件的id名: 控件对应的表单数据}),回填数据
    >>例子：this.form.setFieldsValue({userName: '张三'})
    */
  },
  methods: {
    // 添加下拉树形key,value
    addTreeAttribute(arr) {
      for (let len = 0; len < arr.length; len++) {
        arr[len].value = arr[len].id;
        arr[len].key = arr[len].id;
        if (arr[len].children) {
          arr[len].disabled = true;
          this.addTreeAttribute(arr[len].children);
        }
      }
    },
    // 获取架构区域列表--所属区域
    async getDoorEquGroupList() {
      this.treeSpinning = true;
      //   this.statusServices = ACServices.GetStatus;
      const { status, result } = await ACServices.getList();
      this.treeSpinning = false;
      if (status === 0) {
        let data = [result];
        this.addTreeAttribute(data);
        this.treeData = data;
      }
    },
    // 获取行政区域列表
    async getAreaCodeList() {
      const { status, result } = await ACServices.GetAreaCode();
      if (status === 0) {
        this.treeAreaData = result;
      }
    },
    // 获取区域类型列表
    async getRegionTypeList() {
      const { status, result } = await ACServices.GetRegionType();
      if (status === 0) {
        this.regionTypeData = result;
      }
    },
    // 获取场景路由列表
    async getScenesTypeList() {
      const { status, result } = await ACServices.GetScenes();
      if (status === 0) {
        this.scenesData = result;
      }
    },
    // 获取场核酸列表
    getpcrRulesTypeList() {
      this.pcrRulesTypeData = [
        { code: 1, name: "匹配地方政策" },
        { code: 2, name: "24小时内" },
        { code: 3, name: "48小时内" },
        { code: 4, name: "72小时内" },
        { code: 5, name: "不要求" }
      ];
    },
    // 拾取坐标
    async Fun_Map() {
      this.modalArr.coordinates = await this.form.getFieldValue(
        "longitudeAndLatitude"
      );
      this.showModal = true;
    },
    // 弹框确定
    handleModalOk(val) {
      this.form.setFieldsValue({
        longitudeAndLatitude: val
      });
      this.showModal = false;
    },
    // 弹框取消
    handleModalCancel() {
      this.showModal = false;
    },
    // 选中一码通btn
    Fun_selectBtn(num) {
      // console.log(num, "num");
      this.checkFlag = false;
      this.selectBtn = num;
      if (this.selectBtn == 0 || this.selectBtn == 2 || this.selectBtn == 3) {
        // console.log("不用检查", this.selectBtn);
        this.checkFlag = false;
      } else {
        // console.log("检查", this.selectBtn);
        this.checkFlag = true;
      }
    },

    // 获取门禁设备详细数据
    async getInfo() {
      //   this.formLoading = true;
      let { result, status } = await ACServices.GetInfo({ id: this.id });
      if (status === 0) {
        if (result.healthCodeParameter) {
          this.healthCodeParameterStr = JSON.parse(result.healthCodeParameter);

          result.healthCodeParameter = JSON.parse(result.healthCodeParameter);
        } else {
          this.healthCodeParameterStr = result.healthCodeParameter;
          result.healthCodeParameter = result.healthCodeParameter;
        }
        this.scenesStr = result.scenes;
        this.doorSecretStr = result.doorSecret;
        this.selectBtn = result.healthCodeType;

        this.$nextTick(() => {
          this.form.setFieldsValue({
            longitudeAndLatitude:
              result.healthCodeParameter.longitudeAndLatitude,
            eventInOut: result.healthCodeParameter.eventInOut,
            regionCode: result.healthCodeParameter.regionCode,
            installLocation: result.healthCodeParameter.installLocation,
            regionType: result.healthCodeParameter.regionType,
            Qrid: result.healthCodeParameter.Qrid,
            doorSecret: result.doorSecret,
            scenes: result.scenes,
            pcrRules: result.healthCodeParameter.pcrRules || 5,
            // eventType: result.healthCodeParameter.eventType,
            placeguid: result.healthCodeParameter.placeguid,
            appid: result.healthCodeParameter.appid,
            areacode: result.healthCodeParameter.areacode,
            faceMode:
              result.healthCodeParameter.faceMode === undefined
                ? true
                : result.healthCodeParameter.faceMode
          });

          if (result.healthCodeParameter.eventType === 2) {
            // 2：扫码不匹配底库、身份证不匹配底库
            this.form.setFieldsValue({
              eventType2: false,
              eventType3: false
            });
          }
          if (result.healthCodeParameter.eventType === 3) {
            // 3：扫码匹配底库、身份证匹配底库
            this.form.setFieldsValue({
              eventType2: true,
              eventType3: true
            });
          }
          if (result.healthCodeParameter.eventType === 4) {
            // 5：扫码匹配底库、身份证不匹配底库
            this.form.setFieldsValue({
              eventType2: false,
              eventType3: true
            });
          }
          if (result.healthCodeParameter.eventType === 5) {
            // 2：扫码不匹配底库、身份证不匹配底库
            this.form.setFieldsValue({
              eventType2: true,
              eventType3: false
            });
          }
        });
      }
      this.formLoading = false;
    },

    //判断核查类型
    checkEventType(value) {
      let eventType = null;
      if (!value.eventType2 && !value.eventType3) {
        // 2：扫码不匹配底库、身份证不匹配底库
        eventType = 2;
      }
      if (value.eventType2 && value.eventType3) {
        // 3：扫码匹配底库、身份证匹配底库
        eventType = 3;
      }
      if (!value.eventType2 && value.eventType3) {
        // 4：扫码不匹配底库、身份证匹配底库
        eventType = 4;
      }
      if (value.eventType2 && !value.eventType3) {
        // 5：扫码匹配底库、身份证不匹配底库
        eventType = 5;
      }
      return eventType;
    },
    //校验人脸模式
    CheckfaceMode(rule, value, callback) {
      console.log(value, "value");
      if (value) {
        this.isfacemodedisabled = false;
      } else {
        this.isfacemodedisabled = true;
        this.form.setFieldsValue({
          eventType2: false,
          eventType3: false
        });
      }
      callback();
    },

    /**
     * 提交表单
     */
    async handleSubmit(e) {
      let formdata = [];
      let healthCodeParameter = {};
      let healthCodeType = this.selectBtn;
      let doorSecret = "";
      let scenes = "";
      let desc = "";
      this.btnLoading = true;
      let errFlag = true;
      let eventTypes = {};
      let eventType2 = this.form.getFieldValue("eventType2");
      let eventType3 = this.form.getFieldValue("eventType3");
      eventTypes = {
        eventType2: eventType2,
        eventType3: eventType3
      };
      // formdata = this.form.getFieldsValue();
      //不接入健康码--不用验证--保存原来的数据
      if (this.selectBtn == 0) {
        healthCodeParameter = this.healthCodeParameterStr;
        errFlag = false;
        scenes = this.scenesStr;
        doorSecret = this.doorSecretStr;
      }
      //新疆防疫--验证必填项--当前页面没有的属性按原来的属性保存
      if (this.selectBtn == 2) {
        this.form.validateFields(
          ["eventType", "placeguid", "appid", "areacode", "faceMode"],
          async (err, values) => {
            let eventType = this.checkEventType(eventTypes);
            if (!err) {
              errFlag = false;
              healthCodeParameter = {
                longitudeAndLatitude: this.healthCodeParameterStr
                  .longitudeAndLatitude,
                regionCode: this.healthCodeParameterStr.regionCode,
                regionType: this.healthCodeParameterStr.regionType,
                eventInOut: this.healthCodeParameterStr.eventInOut,
                installLocation: this.healthCodeParameterStr.installLocation,
                Qrid: this.healthCodeParameterStr.Qrid,
                pcrRules: this.healthCodeParameterStr.pcrRules,
                eventType: eventType,
                placeguid: values.placeguid,
                appid: values.appid,
                areacode: values.areacode,
                faceMode: values.faceMode
              };
            }
          }
        );
        scenes = this.scenesStr;
        doorSecret = this.doorSecretStr;
      }
      //河北健康码
      if (this.selectBtn == 3) {
        errFlag = false;
        healthCodeParameter = this.healthCodeParameterStr;
        scenes = this.scenesStr;
        doorSecret = this.doorSecretStr;
      }
      //陕西一码通
      if (this.selectBtn == 1) {
        this.form.validateFields(
          [
            "longitudeAndLatitude",
            "eventInOut",
            "regionCode",
            "installLocation",
            "regionType",
            "Qrid",
            "pcrRules",
            "eventType",
            "faceMode"
          ],
          async (err, values) => {
            let eventType = this.checkEventType(eventTypes);
            if (!err) {
              errFlag = false;
              healthCodeParameter = {
                longitudeAndLatitude: values.longitudeAndLatitude,
                regionCode: values.regionCode,
                regionType: values.regionType,
                eventInOut: values.eventInOut,
                installLocation: values.installLocation,
                Qrid: values.Qrid,
                pcrRules: values.pcrRules,
                eventType: eventType,
                placeguid: this.healthCodeParameterStr.placeguid,
                appid: this.healthCodeParameterStr.appid,
                areacode: this.healthCodeParameterStr.areacode,
                faceMode: values.faceMode
              };
              doorSecret = this.doorSecretStr;
              scenes = this.scenesStr;
            }
          }
        );
      }
      // 西安纳管，宝鸡纳管
      if (this.selectBtn == 5 || this.selectBtn == 4) {
        this.form.validateFields(
          [
            "longitudeAndLatitude",
            "eventInOut",
            "regionCode",
            "installLocation",
            "regionType",
            "Qrid",
            "pcrRules",
            "doorSecret",
            "scenes",
            "eventType",
            "faceMode"
          ],
          async (err, values) => {
            let eventType = this.checkEventType(eventTypes);
            if (!err) {
              errFlag = false;
              healthCodeParameter = {
                longitudeAndLatitude: values.longitudeAndLatitude,
                regionCode: values.regionCode,
                regionType: values.regionType,
                eventInOut: values.eventInOut,
                installLocation: values.installLocation,
                Qrid: values.Qrid,
                pcrRules: values.pcrRules,
                eventType: eventType,
                placeguid: this.healthCodeParameterStr.placeguid,
                appid: this.healthCodeParameterStr.appid,
                areacode: this.healthCodeParameterStr.areacode,
                faceMode: values.faceMode
              };
              doorSecret = values.doorSecret;
              scenes = values.scenes;
            }
          }
        );
      }

      if (
        this.selectBtn !== 0 &&
        this.selectBtn !== 1 &&
        this.selectBtn !== 2 &&
        this.selectBtn !== 3 &&
        this.selectBtn !== 4 &&
        this.selectBtn !== 5
      ) {
        console.log(
          "其他健康吗",
          this.healthCodeParameterStr,
          "this.healthCodeParameterStr"
        );
        healthCodeParameter = this.healthCodeParameterStr;
        errFlag = false;
        scenes = this.scenesStr;
        doorSecret = this.doorSecretStr;
      }
      if (!errFlag) {
        console.log(this.selectBtn, "this.selectBtn");

        const { status, result } = await ACServices.UpdateDoorEqu({
          sn: this.id,
          healthCodeType: healthCodeType,
          healthCodeParameter: JSON.stringify(healthCodeParameter),
          doorSecret: doorSecret,
          scenes: scenes
        });
        if (status === 0) {
          let oldUser = window.sessionStorage.getItem("username");
          if (this.oldUserPhone === oldUser) {
            window.sessionStorage.setItem("username", values.userPhone);
          }
          desc = "修改成功";
          this.notification("success", "成功", desc);
          this.$router.push("/access-control");
        }
      }

      this.btnLoading = false;
    }

    // this.$router.go(-1)
  }
};
</script>
<style lang="less" scoped>
// @import url(); 引入公共css类
.account-ec {
  width: 100%;
  min-height: 800px;
  margin: 0 auto;
  background: rgba(255, 255, 255, 1);
  border-radius: 10px;
  .content-wrap {
    height: 540px;
    margin: 0 16px 16px;
    padding: 24px;
    background: #ffffff;
    display: flex;
    flex-direction: column;
    .page-title {
      font-size: 18px;
      color: #5862cb;
      // margin-bottom: 140px !important;
    }
    .from-wrap {
      padding: 120px 12%;
      flex: 1;
      // display: flex;
      // align-items: center;
      // justify-content: center;

      .onecode-item {
        min-height: 300px;
      }

      .select-btn {
        padding: 16px;
        height: 56px;
        border: 2px solid #dadfe6;
        text-align: center;
        margin-left: 24px;
        border-radius: 6px 6px 6px 6px;
        cursor: pointer;
        font-size: 16px;
        font-family: Roboto-Regular, Roboto;
        font-weight: 400;
        position: relative;
        overflow: hidden;

        .select-logo {
          width: 28px;
          height: 27px;
          position: absolute;
          right: 0;
          top: 27px;
        }
      }
      .item-input {
        max-width: 296px;
        // margin-left: 10px;
      }

      // .form-btn {
      // width: 100%;
      // background-color: #5f9988;

      .btn-wrap {
        display: flex;
        justify-content: center;
        align-items: center;
        .tool-btn {
          width: 88px;
          height: 32px;
          border-radius: 3px;
        }
      }
      // }
    }
  }
}
</style>
